import { ConversationMembersDataResponse } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "../useChatApi";

export function useChatConversationMembers(
  id: number,
  accessToken: string,
  top: number,
  options?: UseQueryOptions<ConversationMembersDataResponse>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-conversations-members", id, accessToken, top],
    queryFn: async () => {
      const { data } = await api.conversationMembers(id, accessToken, top);
      return data;
    },
    ...options,
  });
}
